import { ENDPOINTS } from '@/util'
import { useSuspenseQuery } from '@tanstack/react-query'
import type { RestSchemas } from '@/contexts/QueryProvider'

type ListSharedFilesResult = RestSchemas['Messages.Storage.ListSharedFilesResult']

const listSharedFiles = async (appKey: string): Promise<ListSharedFilesResult> => {
  const rawToken = sessionStorage.getItem('token')
  if (!rawToken) throw new Error('No token found')
  const token = JSON.parse(rawToken) as string

  const response = await fetch(`${ENDPOINTS.DOTNET}/rest/storage/list_shared_files`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ appKey }),
  })

  if (!response.ok) throw new Error('Failed to list shared files')
  return (await response.json()) as ListSharedFilesResult
}

export const sharedFilesQueryKey = (appKey: string) => ['list-shared-files', appKey] as const

export function useListSharedFiles(appKey: string) {
  return useSuspenseQuery({
    queryKey: sharedFilesQueryKey(appKey),
    queryFn: () => listSharedFiles(appKey),
  })
}
